import dayjs from 'dayjs';
import gql from 'graphql-tag';

import { useMetricQueries } from '../../lib/hooks';
import { createBatchedFetcher } from '../../lib/gqlFetcher_myf2b';

const fetcher = createBatchedFetcher(5);

const QUERY = gql`
	query metrics_contentTreeActivityStream(
		$entityType: EntityType!,
		$entityId: ID!,
		$curriculumId: String!,
		$path: ContentTreePath!,
	) {
		metrics(entityId: $entityId, entityType: $entityType) {
			contentTreeActivityStream(curriculumId: $curriculumId, path: $path){
				path
				contentId
				score
				startedAt
				timeSpent
				mastered
			}
		}
	}
`;

const useContentTreeActivityStreams = (entities) => useMetricQueries(
	entities.map(
		([entityType, entityId, curriculumId, path]) => ({
			document: QUERY,
			variables: { entityType, entityId, curriculumId, path },
			options: {
				queryKey: ['metrics_contentTreeActivityStream', entityType, entityId, curriculumId, path],
				transformer: ({ metrics: { contentTreeActivityStream } }) => ({
					entityType,
					entityId,
					curriculumId,
					path,
					stream: contentTreeActivityStream.map(entry => ({
						...entry,
						startedAt: entry.startedAt && dayjs(entry.startedAt),
					})),
				}),
			},
		})
	),
	fetcher,
);
export default useContentTreeActivityStreams;
